import { doNothing } from "@kazoohr/helpers";

import { onBrowser } from "./onBrowser";

export function useBlurHandlers(onBlur: () => void) {
  let closingTimeoutId: any;

  // istanbul ignore next - node short-circuit
  if (!onBrowser()) {
    return [doNothing, doNothing];
  }
  // We close the popover on the next tick by using setTimeout.
  // This is necessary because we need to first check if
  // another child of the element has received focus as
  // the blur event fires prior to the new focus event.
  // Source: https://reactjs.org/docs/accessibility.html#mouse-and-pointer-events
  const onBlurHandler = () => {
    closingTimeoutId = setTimeout(onBlur);
  };
  // If a child receives focus, do not close the popover.
  const onFocusHandler = () => {
    clearTimeout(closingTimeoutId);
  };

  return [onBlurHandler, onFocusHandler];
}
